import React from 'react';
import { Link } from 'react-router-dom';
import ProductActionButton from './ProductActionButton';
import './ProductCard.css';

const MyInterestProductCard = ({ product }) => {
  return (
      <div className="product-card-horizontal" id={"goodsView"+product.goods_seq}>
        <Link className="pch-to-detail" to={`/store/goods/${product.goods_seq}`}>
          <div className="pch-thumb">
            <img src={"https://cdn.cokeplay.cocacola.co.kr" + product.tb_store_goods.list1_image_url} alt="" className="pch-image" loading="lazy"/>
          </div>
          <div className="pch-info">
            <div className="pch-display-goods-name">{product.tb_store_goods.display_goods_name}</div>
            <div className="pch-price">
                <div>
                    {product.tb_store_goods.discount_price && (
                    <span>{Math.round(((product.tb_store_goods.price - product.tb_store_goods.discount_price) / product.tb_store_goods.price) * 100)}%</span>)}
                    <span>{product.tb_store_goods.discount_price ? product.tb_store_goods.discount_price.toLocaleString() : product.tb_store_goods.price.toLocaleString()}</span>
                    <span>원</span>
                </div>
                <div>
                    {product.tb_store_goods.discount_price && (<span>{product.tb_store_goods.price.toLocaleString()}원</span>)}
                </div>
            </div>
          </div>
        </Link>
        <ProductActionButton goods_seq={product.goods_seq} bottom="10px" right="5px"/>
      </div>)
};

export default MyInterestProductCard; 


